import { BRAND } from "../lib/site";

// Shared "Contact & registered details" block for all legal / policy pages.
export function RegisteredDetails() {
  return (
    <p data-testid="registered-details">
      <strong className="text-[#F5F5F0]">Vinci Inc.</strong><br />
      <span className="text-[#8A8A82]">{BRAND.enquiry}</span><br />
      <span className="text-[#C9C9C2]">For any queries or doubts :</span><br />
      Email us at : <a href={`mailto:${BRAND.email}`} className="text-[#B87333] hover:underline">{BRAND.email}</a><br />
      Alt. email : <a href={`mailto:${BRAND.altEmail}`} className="text-[#B87333] hover:underline">{BRAND.altEmail}</a><br />
      Phone: <a href={`tel:${BRAND.phones[0].replace(/\s/g, "")}`} className="text-[#B87333] hover:underline">{BRAND.phones[0]}</a> &nbsp;/&nbsp; <a href={`tel:${BRAND.phones[1].replace(/\s/g, "")}`} className="text-[#B87333] hover:underline">{BRAND.phones[1]}</a>
    </p>
  );
}
